import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Shield } from 'lucide-react'

const sections = [
  {
    title: '1. Pendahuluan',
    content:
      'UMKM Indonesia ("kami") menghormati privasi Anda. Kebijakan Privasi ini menjelaskan bagaimana kami mengumpulkan, menggunakan, menyimpan, dan melindungi data pribadi Anda saat menggunakan platform katalog digital UMKM Indonesia.',
  },
  {
    title: '2. Data yang Kami Kumpulkan',
    content:
      'Kami dapat mengumpulkan informasi berikut saat Anda mendaftar dan menggunakan layanan kami:',
    list: [
      'Data akun: nama, alamat email, dan kata sandi (disimpan dalam bentuk terenkripsi)',
      'Data usaha: nama brand, deskripsi, logo, alamat, nomor WhatsApp, dan tautan media sosial',
      'Data produk: nama produk, harga, deskripsi, dan gambar produk',
      'Data transaksi: riwayat pembayaran langganan melalui penyedia pembayaran pihak ketiga',
      'Data teknis: alamat IP, jenis perangkat, browser, dan aktivitas penggunaan platform',
    ],
  },
  {
    title: '3. Cara Kami Menggunakan Data',
    content: 'Data yang kami kumpulkan digunakan untuk:',
    list: [
      'Menyediakan dan mengelola akun serta katalog online Anda',
      'Memproses pembayaran langganan dan layanan terkait',
      'Menampilkan katalog usaha Anda kepada pelanggan',
      'Meningkatkan kualitas layanan dan pengalaman pengguna',
      'Mengirim informasi penting terkait akun atau layanan',
      'Menjaga keamanan platform dan mencegah penyalahgunaan',
    ],
  },
  {
    title: '4. Pembagian Data kepada Pihak Ketiga',
    content:
      'Kami tidak menjual data pribadi Anda. Kami hanya membagikan data kepada pihak ketiga yang diperlukan untuk menjalankan layanan, seperti penyedia pembayaran (Midtrans), layanan hosting, dan analitik website (Google Analytics). Pihak ketiga tersebut wajib menjaga kerahasiaan data sesuai peraturan yang berlaku.',
  },
  {
    title: '5. Penyimpanan dan Keamanan Data',
    content:
      'Kami menerapkan langkah-langkah keamanan yang wajar untuk melindungi data Anda dari akses, perubahan, atau pengungkapan yang tidak sah. Namun, tidak ada sistem yang sepenuhnya aman di internet. Kami menyarankan Anda menggunakan kata sandi yang kuat dan menjaga kerahasiaan kredensial akun.',
  },
  {
    title: '6. Hak Anda',
    content: 'Sebagai pengguna, Anda berhak untuk:',
    list: [
      'Mengakses dan memperbarui data profil serta data usaha melalui menu Pengaturan',
      'Meminta penghapusan akun dan data terkait dengan menghubungi kami',
      'Menolak penggunaan data untuk keperluan tertentu, sejauh diizinkan oleh hukum',
    ],
  },
  {
    title: '7. Cookie dan Analitik',
    content:
      'Platform kami menggunakan cookie dan teknologi serupa untuk meningkatkan pengalaman pengguna serta menganalisis lalu lintas website melalui Google Analytics. Anda dapat mengatur preferensi cookie melalui pengaturan browser Anda.',
  },
  {
    title: '8. Data Katalog Publik',
    content:
      'Informasi yang Anda publikasikan di katalog usaha (nama brand, produk, kontak, dan media sosial) akan dapat diakses oleh pengunjung dan mesin pencari. Pastikan Anda hanya membagikan informasi yang ingin ditampilkan secara publik.',
  },
  {
    title: '9. Perubahan Kebijakan',
    content:
      'Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu. Perubahan akan diumumkan di halaman ini dengan tanggal pembaruan terbaru. Penggunaan layanan setelah perubahan berarti Anda menyetujui kebijakan yang diperbarui.',
  },
  {
    title: '10. Hubungi Kami',
    content:
      'Jika Anda memiliki pertanyaan terkait Kebijakan Privasi ini atau ingin mengajukan permintaan terkait data pribadi, silakan hubungi kami melalui menu Hubungi Kami di website atau WhatsApp yang tersedia di platform UMKM Indonesia.',
  },
]

export default function Privacy() {
  useEffect(() => {
    document.title = 'Kebijakan Privasi | UMKM Indonesia'
    return () => {
      document.title = 'UMKM Indonesia - Katalog Pro'
    }
  }, [])

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14">
      <div className="text-center mb-10">
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-indigo-100 text-indigo-600 mb-4">
          <Shield className="w-7 h-7" />
        </div>
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">Kebijakan Privasi</h1>
        <p className="text-gray-600">
          Terakhir diperbarui: 11 Juni 2025
        </p>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 md:p-10 space-y-8">
        {sections.map((section) => (
          <section key={section.title}>
            <h2 className="text-lg font-semibold text-gray-900 mb-3">{section.title}</h2>
            <p className="text-gray-600 leading-relaxed">{section.content}</p>
            {section.list && (
              <ul className="mt-3 space-y-2">
                {section.list.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-gray-600 text-sm leading-relaxed">
                    <span className="text-indigo-500 mt-1.5 shrink-0">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>

      <p className="text-center text-sm text-gray-500 mt-8">
        <Link to="/" className="text-indigo-600 hover:text-indigo-800 font-medium">
          ← Kembali ke Beranda
        </Link>
      </p>
    </div>
  )
}
